/*
 * @Date: 2019-08-22 14:29:05
 * @LastEditors: x
 * @LastEditTime: 2022-01-10 10:28:42
 */
import api from  './api'

const url = 'ticket'

export default {
  /**
   * @description: 提交工单 
   */
  sendTicketQuestion(data) {
    return api.post(`${url}/Question`, data)
  },
  /**
   * @description: 工单详情 
   * @return: 
   */
  getTicketDetail() {
    return api.get(`${url}/Detail`)
  },
/**
 * @description: 工單是否已回復 
 * @return: 
 */  
  getHadReplay() {
    return api.get(`${url}/HadReplay`)
  },
/**
 * @description: 是否有正在处理的工单
 * @param {*}
 * @return {*}
 */  
  getHadNoReply() {
    return api.get(`${url}/HadNoReply`)
  }
}


// WEBPACK FOOTER //
// ./src/api/ticket.js